import { createContext } from 'react';

const ColumnMenuContext = createContext({
  onColumnsChange: () => {},
  columns: [],
  columnsState: []
});

export default ColumnMenuContext;
